import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './locales/zh.json'
import en from './locales/en.json'
import ja from './locales/ja.json'
import fr from './locales/fr.json'
Vue.use(VueI18n);
// 从 localStorage 读取语言设置，如果没有则使用默认语言 'zh'
const locale = localStorage.getItem('language') || 'en';

const i18n = new VueI18n({
  locale: locale, // 默认语言
  fallbackLocale: 'en', // 回退语言
  messages: {
    zh,
    en,
    ja,
    fr
  }
})

export default i18n